import React from "react";
import { Link, useHistory } from "react-router-dom";

export default function ServiceCard(props) {
  const history = useHistory();

  return (
    <div
      className="w-full rounded-[12px] border-[1px] border-lightGray2"
      onClick={() => {
        window.scroll(0, 0);
        history.push(props.linkTo);
      }}
    >
      <div
        className="cursor-pointer h-[250px] bg-lightGray rounded-t-[12px] !bg-cover"
        style={{
          background:
            props.image &&
            `url(${process.env.REACT_APP_API_URL}${props.image}), #D9D9D9`,
        }}
      />
      <div className="p-[20px]">
        <div>
          <p className="cursor-pointer text-[20px] xl:text-[24px] text-left">
            {props.name}
          </p>
          <div className="flex justify-end">
            <Link
              to={props.linkTo}
              className="text-[14px] xl:text-[16px] mt-[10px] text-right text-blue font-bold cursor-pointer"
              onClick={() => {
                window.scroll(0, 0);
              }}
            >
              {props.lang === "th" ? "อ่านเพิ่มเติม" : "Read More"}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
